"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PromiseWrapper_1 = __importDefault(require("./PromiseWrapper"));
/**
 * Help facilitate key obtention, caching and management. Allows keys to be
 * obtained based on issuer and keyid attribute. Search by key id is possible,
 * but will always return an array, of hopefully only 1 object, but that is not
 * assured since the key id are not defined by this object.
 */
var KeyRing = /** @class */ (function () {
    function KeyRing(fetch) {
        this.issuers = {};
        this.fetch = fetch;
        this.promiseWrapper = new PromiseWrapper_1.default();
    }
    KeyRing.prototype.obtain = function (issuer, keyid, telemetry) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(issuer in this.issuers)) {
                            this.issuers[issuer] = {};
                        }
                        if (!(keyid in this.issuers[issuer])) {
                            this.issuers[issuer][keyid] = this.promiseWrapper.wrap(this._fetch, this);
                        }
                        return [4 /*yield*/, this.issuers[issuer][keyid](issuer, keyid, telemetry)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Used internaly
     *
     * will use the fetch method, and handle if an array of Public Key is
     * returned
     */
    KeyRing.prototype._fetch = function (issuer, keyid, telemetry) {
        return __awaiter(this, void 0, void 0, function () {
            var key_or_keys, my_key;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch(issuer, keyid, telemetry)];
                    case 1:
                        key_or_keys = _a.sent();
                        if (key_or_keys === null || !(key_or_keys instanceof Array)) {
                            return [2 /*return*/, key_or_keys];
                        }
                        my_key = null;
                        key_or_keys.forEach(function (key) {
                            if (key.keyid === keyid) {
                                my_key = key;
                            }
                            // do not overwrite what was there, but keep it if it
                            // wasn't defined yet
                            else if (!(key.keyid in _this.issuers[issuer])) {
                                _this.issuers[issuer][key.keyid] = function () { return key; };
                            }
                        });
                        return [2 /*return*/, my_key];
                }
            });
        });
    };
    return KeyRing;
}());
exports.default = KeyRing;
